export default __webpack_public_path__ + "static/hero-pattern-2205a718fe213fbf098e13f97f24d402.webp";